import {Tag} from '../models/tag.model';
import {ProductRepository} from '../repository/ProductRepository';

export class GetAllTagsUseCase {
  constructor (private repo: ProductRepository) {}

  async execute (): Promise<Tag[]> {
    return this.repo.getTags();
  }
}
